// extracted by mini-css-extract-plugin
export default {"container":"MonthNavigation_container__qkaTj","layout":"MonthNavigation_layout__bInPG","rightSection":"MonthNavigation_rightSection__gp28q"};